"use client";

import React, { useState, useEffect } from "react";
import styles from "./menu.module.css";
import { faChartSimple, faDashboard } from "@fortawesome/free-solid-svg-icons";
import {
  faFileLines,
  faFolder,
  faSun,
  faUser,
  faPaperPlane,
} from "@fortawesome/free-regular-svg-icons";

import { useSidebarContext } from "../Context";
import SidebarMenuItem from "./MenuItem";

const menuIcons = {
  Dashboard: faChartSimple,
  "User Management": faUser,
  "AAJ Swift TMS": faPaperPlane,
  Reports: faFileLines,
  Masters: faFolder,
  Settings: faSun,
};

const Menu = ({ appModules }) => {
  // const [menuData, setMenuData] = useState([]);
  const [activeMenu, setActiveMenu] = useState(null);
  const [anchorE1, setAnchorE1] = useState(null); // State to manage the anchor element for the menu

  const { isSidebarCollapsed } = useSidebarContext();

  const handleMenuClick = (event, item) => {
    const isSubMenu = Boolean(item?.children?.length);

    if (isSubMenu && !isSidebarCollapsed) {
      setActiveMenu(item.name === activeMenu ? null : item.name); // Toggle active menu
    } else if (isSubMenu && isSidebarCollapsed) {
      setActiveMenu(item.name); // Toggle active menu
    }
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const { data } = await getMenuData();
  //     if (data) setMenuData(data);
  //   };

  //   fetchData();
  // }, []);

  return (
    <div className={styles.container}>
      <div
        className={`${styles.menu_container} ${
          isSidebarCollapsed ? styles.collapsed : ""
        }`}
      >
        {appModules
          .filter((menu) => !menu.isAccount)
          .map((item, index) => (
            <SidebarMenuItem
              key={index}
              icon={menuIcons[item.name] || faDashboard} // fallback icon
              label={item.name}
              children={item.children}
              url={item.url}
              onClick={(event) => handleMenuClick(event, item)}
              activeMenu={activeMenu}
              setAnchorE1={setAnchorE1}
              anchorEl={anchorE1}
            />
          ))}
      </div>
    </div>
  );
};

export default Menu;

async function getMenuData() {
  try {
    const response = await fetch("/nav.json");
    const data = await response.json();
    return { isLoading: false, data, error: null };
  } catch (error) {
    console.error("Error fetching menu data:", error);
    return { isLoading: false, data: null, error };
  }
}
